export default __webpack_public_path__ + "static/csc-48bcaef6ae9bb06e72b518988ea95ca5.svg";